import { SET_APP_TITLE } from "../../constants/MainConstants";

const initialState: MainStateType = {
    appTitle: ""
};

export default (state = initialState, action: any) => {
    switch (action.type) {
        case SET_APP_TITLE:
            return {
                ...state,
                appTitle: action.appTitle
            };
        default:
            return state;
    }
};
